import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const CustomTabBar = ({
  tabs,
  activeTab,
  onTabChange,
  bgClass = "apointments-bg",

  activeClass = "appointments-nav-active",
  inactiveClass = "appointments-nav-inactive"
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <div className={`w-[98.5%] ml-2  ${bgClass}  rounded-t-md `} >
      <nav className={` border rounded-md p-1`}>
        <div className="container mx-auto ">
          <ul className="flex text-sm">

            {tabs.map((tab, index) => {

              // Dropdown tab
              if (tab.dropdown) {
                return (
                  <li key={index} className={`relative p-2 w-30 ${tab.dropdown.some(d => d.value === activeTab) ? activeClass : inactiveClass
                    }`}>
                    <button
                      className={`flex items-center gap-2 `}
                      onClick={() =>
                        setOpenDropdown(openDropdown === index ? null : index)
                      }
                    >
                      {tab.label}
                      <FaChevronDown
                        className={`transition-transform duration-200 ${openDropdown === index ? "rotate-180" : ""
                          }`}
                      />
                    </button>

                    {openDropdown === index && (
                      <ul className={`absolute top-full left-0 z-10 w-[135px] mt-0.5 `}>
                        {tab.dropdown.map((item, i) => (
                          <li
                            key={i}
                            className={` shadow-xl w-[122px] p-2  ${activeTab === item.value ? activeClass : inactiveClass
                              }`}
                            onClick={() => {
                              onTabChange(item.value);
                              setOpenDropdown(null);
                            }}
                          >
                            {item.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }

              // Normal tab
              return (
                <li
                  key={index}
                  className={`w-30 ${activeTab === tab.value ? activeClass : inactiveClass
                    }`}
                >
                  <button
                    className="text-white p-2 h-full"
                    onClick={() => {
                      onTabChange(tab.value);
                      setOpenDropdown(null)
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

    </div>
  );
};

export default CustomTabBar;
